export interface CookieState {
  consent: boolean | undefined
}

export enum cookiesEnum {
  consent = 'user_cookie_consent'
}
